import React, {Component} from 'react';
import swal from 'sweetalert';
import Layout from '../../../components/Auth/Layout';
import classes from './ForgotPassword.css';
import Button from '../../../components/Nifty/UI/Button/Button';
import {Link} from 'react-router-dom';
import {Httpphp} from '../../../axiosInstances';
//import axios from 'axios';
class ForgotPassword extends Component{

   constructor(props) {
    super(props);
    this.state = {value: ''};
    this.emailInput = React.createRef();
    this.focus = this.focus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

   handleChange(event) {
    this.setState({value: event.target.value});
  }

   handleSubmit= (event) => {
    event.preventDefault();
   	//el evento cuando se unde el boton
   	
       if(this.validate(this.state)){
            //console.log('A name was submitted: ' + this.state.value);//debugger;
            let email = this.state.value;
            if (email.trim() !== '') {
            try {
                  let formData = new FormData();
                    formData.append('email', email);
                    Httpphp.post(
                       //`http://localhost:8080/php-back-web/restPassword.php`,
                       "/php-prueba/restPassword.php",
                       //"http://set-icap.com.co/php-prueba/restPassword.php",
                        formData,
                        {
                            headers: {
                                //"Accept": "application/json, text/plain, /",
                                //"Content-type": "multipart/form-data"
                            },                    
                        }
                    )
                    .then(res => { // debugger;
                        //window.alert(res.data.toString()); 

                        if(res.data.toString() == '') {
                            swal('Hemos enviado a tu correo electrónico un enlace para la recuperación de tu contraseña.');
                        } else {
                            swal({
                                title: 'Información',
                                text: 'Hemos enviado a tu correo electrónico un enlace para la recuperación de tu contraseña.',
                                button: 'Ok'}); 
                        }

                        var reset = document.getElementById("email");
                        reset.value = "";
                    })
                    .catch(err => {
                        swal({
                            title: 'Pedimos disculpas',
                            text: err.message, 
                            button: 'Acepto'});  
                        var reset = document.getElementById("email");
                        reset.value = "";
                    })

              } catch (error) {
                //// console.log(error);
              }
            }
       }else{

           this.focus();
       }
  }
  focus() {
    this.emailInput.current.focus();
  }
   validate(values) {
      if (!values.value) { //debugger;
          swal("Por favor, no deje el campo de correo electrónico vacio");
        return false;
      } else if (!/\S+@\S+\.\S+/.test(values.value)) {
        return false;
      }
      return true;
    }


    render(){

        return(
            <Layout>
                <div className="panel-body">
               <div className={['mar-ver', 'pad-btm', classes.TitleSection].join(' ')}>
                  <h1 className="h3">¿Olvidaste tu contraseña?</h1>
                  <p className="pad-btm">Ingrese su correo electrónico para recuperar su contraseña</p>
               </div>
                  <form encType="multipart/form-data">
                      <div className="form-group ">
                          <input id="email" name="email" type="email" ref={this.emailInput} value={this.state.value} onChange={this.handleChange} placeholder="Email"className="form-control" required/>
                      </div>
                      <div className="form-group text-right">
                          <Button onClick={this.handleSubmit} type="danger">Restablezca la contraseña</Button>
                      </div>
                  </form>
                  <div className="pad-top" style={{textAlign: 'center'}}>
                  <Link to="/auth/login/" className={['btn-link', 'text-bold'].join(' ')}>Regresar al inicio de sesión</Link>
                  </div>
              </div>
            </Layout>
        )
    }
}

export default ForgotPassword;